import React from 'react';

import { Dialog, IconButton } from 'wix-ui-tpa/cssVars';
import { useSidebarLayoutBase } from '../contexts/SidebarLayoutBase/SidebarLayoutBaseContext';
import { useEnvironment, useTranslation } from '@wix/yoshi-flow-editor';
import { Close } from '@wix/wix-ui-icons-common/on-stage';
import loadable from '@wix/yoshi-flow-editor/loadable';

import { classes } from '../SidebarLayoutForParticipant.st.css';

export interface AiChatPanelProps {
  className?: string;
}

const AIChat = loadable(() => {
  return import(/* webpackPrefetch: true */ './AIChat');
});

export const AIChatDialog = () => {
  const { isAiChatEnabled, toggleAiChatVisibility, isAiChatVisible } =
    useSidebarLayoutBase();
  const { isMobile } = useEnvironment();

  if (!isAiChatEnabled) {
    return null;
  }

  if (!isMobile) {
    return null;
  }
  return (
    <Dialog isOpen={isAiChatVisible} onClose={toggleAiChatVisibility}>
      <AIChat />
    </Dialog>
  );
};

export const AiChatPanel: React.FC<AiChatPanelProps> = ({ className }) => {
  const { isAiChatEnabled, toggleAiChatVisibility } = useSidebarLayoutBase();
  const { isMobile } = useEnvironment();
  const { t } = useTranslation();

  if (!isAiChatEnabled) {
    return null;
  }

  if (isMobile) {
    return null;
  }

  return (
    <div className={`${classes.aiChatContainer} ${className || ''}`}>
      <div className={classes.verticalDivider} />
      <div className={classes.aiChatContent}>
        <IconButton
          className={classes.aiChatCloseButton}
          onClick={toggleAiChatVisibility}
          aria-label={t('live-site.ai-chat.close.aria-label')}
          icon={<Close />}
        />
        <AIChat />
      </div>
    </div>
  );
};
